const initializeSiteHeader = (header) => {
  if (header.dataset.initialized === 'true') return;
  header.dataset.initialized = 'true';

  const hero = header.querySelector('.site-header__hero');
  const sticky = header.querySelector('.site-header__sticky');
  const toggle = header.querySelector('.site-header__mobile-toggle');
  const mobileNav = header.querySelector('.site-header__mobile-nav');
  const scrim = header.querySelector('.site-header__mobile-scrim');
  const cartLinks = header.querySelectorAll('.site-header__cart-link');

  header.querySelectorAll('[data-preview-locale-switch]').forEach((link) => {
    if (window.location.hostname !== '127.0.0.1' && window.location.hostname !== 'localhost') return;
    const pagePath = window.location.pathname.replace(/^\/sl(?=\/|$)/, '') || '/';
    const targetPath = link.dataset.previewLocaleSwitch === 'sl' ? `/sl${pagePath}` : pagePath;
    link.href = `${targetPath}${window.location.search}${window.location.hash}`;
    link.hidden = false;
  });

  const updateStickyHeight = () => {
    if (!sticky) return;
    const stickyHeight = Math.ceil(sticky.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--site-header-sticky-height', `${stickyHeight}px`);
  };

  const updateHeader = () => {
    const isCompact = window.scrollY > 96;
    hero?.classList.toggle('is-hidden', isCompact);
    sticky?.classList.toggle('is-visible', isCompact);
    sticky?.setAttribute('aria-hidden', String(!isCompact));
  };

  const closeMenu = () => {
    if (!toggle || !mobileNav || !scrim) return;
    toggle.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    mobileNav.classList.remove('is-open');
    scrim.hidden = true;
  };

  toggle?.addEventListener('click', () => {
    if (!mobileNav || !scrim) return;
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    mobileNav.setAttribute('aria-hidden', String(isOpen));
    mobileNav.classList.toggle('is-open', !isOpen);
    scrim.hidden = isOpen;
  });

  scrim?.addEventListener('click', closeMenu);
  mobileNav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  cartLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      closeMenu();
      if (window.StoneRootsCartDrawer?.openAndRefresh) {
        window.StoneRootsCartDrawer.openAndRefresh();
      } else {
        document.dispatchEvent(new CustomEvent('stone-roots:open-cart'));
      }
    });
  });

  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateStickyHeight, { passive: true });
  updateStickyHeight();
  updateHeader();
};

document.querySelectorAll('.site-header').forEach(initializeSiteHeader);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.site-header').forEach(initializeSiteHeader);
});
